import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["connectButton", "fetchListsButton"]

  static values = {
    connectUrl: String,
    fetchListsUrl: String,
    connected: Boolean,
    fetched: Boolean
  }

  connect() {
    if(this.connectedValue) this.secretConnect();
  }

  async secretConnect(event) {
    event?.preventDefault()

    const secretId = this.getIndexValue(this.element.querySelector('input[name*="[key]"]'))
    await this.updateFrames(secretId);
    const valueInput = this.element.querySelector('input[name*="[value]"]')
    const secretValue = valueInput?.value?.trim()
    const keyInput = this.element.querySelector('input[name*="[key]"]')
    const secretKey = keyInput?.value || "apiKey"
    const icon = this.connectButtonTarget.querySelector('i')
    icon.classList.remove('ph-plugs')
    icon.classList.add('ph-circle-notch', 'ph-spin')

    const formData = new FormData()
    formData.append('value', secretValue)
    formData.append('dom_id', secretId)
    formData.append('key', secretKey)

    fetch(this.connectUrlValue, {
      method: 'POST',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: formData
    })
    .then(response => response.text())
    .then(html => {
      icon.classList.remove('ph-circle-notch', 'ph-spin')
      icon.classList.add('ph-plugs')
      Turbo.renderStreamMessage(html)
      if(this.fetchedValue && this.connectedValue) {
        const that = this
        setTimeout(() => {
          that.fetchLists();
        }, 1000);
      }
    })
  }

  async fetchLists(event) {
    event?.preventDefault()

    const secretId = this.getIndexValue(this.element.querySelector('input[name*="[key]"]'))
    const valueInput = this.element.querySelector('input[name*="[value]"]')
    const secretValue = valueInput?.value?.trim()
    const keyInput = this.element.querySelector('input[name*="[key]"]')
    const secretKey = keyInput?.value || "apiKey"
    const icon = this.fetchListsButtonTarget.querySelector('i')
    icon.classList.remove('ph-list')
    icon.classList.add('ph-circle-notch', 'ph-spin')

    const formData = new FormData()
    formData.append('value', secretValue)
    formData.append('dom_id', secretId)
    formData.append('key', secretKey)

    fetch(this.fetchListsUrlValue, {
      method: 'POST',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: formData
    })
    .then(response => response.text())
    .then(html => {
      icon.classList.remove('ph-circle-notch', 'ph-spin')
      icon.classList.add('ph-list')
      Turbo.renderStreamMessage(html)
    })
  }

  validateSecret(event) {
    event.preventDefault()
    
    const valueInput = event.currentTarget

    if (!valueInput.value.trim()) {
      this.connectButtonTarget.disabled = true
      this.connectButtonTarget.classList.add('bg-gray-400','cursor-not-allowed')
      this.connectButtonTarget.classList.remove('bg-purple-dark')
    } else {
      this.connectButtonTarget.disabled = false
      this.connectButtonTarget.classList.remove('bg-gray-400','cursor-not-allowed')
      this.connectButtonTarget.classList.add('bg-purple-dark')
    }
  }

  getIndexValue(el) {
    const match = el.name.match(/\[integration_secrets_attributes\]\[(\d+)\]/);
    return match ? parseInt(match[1], 10) : this.element.dataset.secretId;
  }

  toggleExcluded(event) {
    const checkbox = event.target
    const row = checkbox.closest("tr")
    const hidden = row.querySelector(".hidden-destination-field")

    hidden.disabled = !checkbox.checked
  }

  updateFrames(secretId) {
    this.element.querySelectorAll('.turboFrames').forEach(frame => {
      if(frame.id.includes(secretId)) return;

      frame.setAttribute('id', `${secretId}_${frame.id}`);
    })
  }
}
